export default {
  init: function() {
    console.log('Disabling Pjax');
    $.pjax.disable();
  }
};